import {
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
	useControllableState,
} from "@chakra-ui/react";
import React from "react";
import ColorPicker from "../color-picker/ColorPicker";
import GradientPicker from "../gradient-picker/GradientPicker";
import { BORDER_COLOR_TYPES, DEFAULT_BORDER_COLOR_TYPE } from "./constants";
import { BorderColorProps } from "./types";
import { useState } from "react";

const tabStyles = {
	borderBottom: "0",
	p: "0",
	outline: "none",
	w: "22px",
	h: "22px",
	border: "1px",
	borderColor: "transparent",
	borderRadius: "base",
	_active: {
		border: "1px",
		borderColor: "primary.500",
	},
	svg: {
		h: "20px",
		w: "20px",
	},
};

export function isGradientString(str: string): boolean {
	return /^(linear|radial|conic)-gradient\s*\(/i.test(str.trim());
}

export const BorderColor = ({ value = "", onChange }: BorderColorProps) => {
	const [index, setIndex] = useState(() => {
		if (isGradientString(value)) {
			return 1;
		}
		return 0;
	});
	return (
		<Tabs index={index} onChange={setIndex} size="sm">
			<TabList borderBottom="0" gap="8px" mb="4">
				<Tab {...tabStyles}>
					<svg
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="0.5"
							y="0.5"
							width="19"
							height="19"
							rx="3.5"
							fill="#DBDBDB"
							stroke="#F4F4F4"
						/>
					</svg>
				</Tab>
				<Tab {...tabStyles}>
					<svg
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="0.5"
							y="0.5"
							width="19"
							height="19"
							rx="3.5"
							fill="url(#paint0_linear_3987_3462)"
							stroke="#F4F4F4"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_3987_3462"
								x1="10"
								y1="0"
								x2="10"
								y2="20"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#222222" />
								<stop offset="1" stopColor="#CDCDCD" />
							</linearGradient>
						</defs>
					</svg>
				</Tab>
			</TabList>
			<TabPanels>
				<TabPanel p="0">
					<ColorPicker
						onChange={(v) => {
							onChange(v);
						}}
						value={isGradientString(value) ? undefined : value}
					/>
				</TabPanel>
				<TabPanel p="0">
					<GradientPicker
						onChange={(v) => {
							onChange(v);
						}}
						value={isGradientString(value) ? value : undefined}
					/>
				</TabPanel>
			</TabPanels>
		</Tabs>
	);
};

export default BorderColor;
